var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNonWorkAsset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 31,
    viewBox: "0 0 35 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.8667 9.60366L31.0333 15.3659H3.96667L5.13333 9.60366H29.8667ZM33.0556 0H1.94444V3.84146H33.0556V0ZM33.0556 5.7622H1.94444L0 15.3659V19.2073H1.94444V30.7317H21.3889V19.2073H29.1667V30.7317H33.0556V19.2073H35V15.3659L33.0556 5.7622ZM5.83333 26.8902V19.2073H17.5V26.8902H5.83333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNonWorkAsset);
export default __webpack_public_path__ + "static/media/nonWorkAsset.443fa6c40d1c15e0dac9c56d7971ed59.svg";
export { ForwardRef as ReactComponent };